// src/hooks/useAxiosWithRedirect.js
import { useNavigate } from "react-router";
import axios from "axios";
import { useEffect } from "react";

export function useAxiosWithRedirect() {
  const navigate = useNavigate();

  const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
  });

  useEffect(() => {
    const interceptor = api.interceptors.response.use(
      (res) => res,
      (error) => {
        if (error.response?.status === 401) {
          navigate("/login");
        }
        return Promise.reject(error);
      }
    );

    return () => api.interceptors.response.eject(interceptor);
    // eslint-disable-next-line
  }, [navigate]);

  return api;
}
